import styled from "@emotion/styled";

import { Share } from "scmp-app/components/article/article-2.0-action-widget/share";
import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";

export const StyledIconContainer = styled.div<ResponsiveStyledProps>`
  justify-content: center;
  align-items: center;

  inline-size: 36px;
  block-size: 36px;

  && > svg:first-child rect {
    stroke: none;
  }

  ${responsiveStyles}
`;

export const StyledShare = styled(Share)`
  && > svg:first-child rect {
    stroke: none;
  }

  && svg:hover {
    background-color: transparent;
  }
`;
